export function customerPayments(request = {}, exchangeRequest = false) {
  const warrantyRequest = request.return_type === "warranty_claim" ||
    (Array.isArray(request.line_items) && request.line_items.some((item) => item.return_type === "warranty_claim"));
  if (!exchangeRequest && !warrantyRequest) return [];
  const payments = Array.isArray(request.payment_details) ? request.payment_details : [];
  const exchangePayments = Array.isArray(request.exchange_payment_details) ? request.exchange_payment_details : [];
  return [...new Map([...exchangePayments, ...payments].map((payment, index) => [payment.id == null ? `row-${index}` : String(payment.id), payment])).values()];
}

export function customerPaymentUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.href : null;
  } catch (_) {
    return null;
  }
}
